module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Meldung"},"fr":{"title":"Message"},"it":{"title":"Notifica"}}')
  delete Component.options._Ctor
}
